import { schema } from 'normalizr';
import { clientSchema } from './clients';

export const ngWordSchema = new schema.Entity('ngWords', {
  client: clientSchema,
});
